import { render, staticRenderFns } from "./GroupBreakdownDrawer.vue?vue&type=template&id=1fa6c0c8&scoped=true"
import script from "./GroupBreakdownDrawer.vue?vue&type=script&lang=js"
export * from "./GroupBreakdownDrawer.vue?vue&type=script&lang=js"
import style0 from "./GroupBreakdownDrawer.vue?vue&type=style&index=0&id=1fa6c0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6c0c8",
  null
  
)

export default component.exports